const BASE_INPUT_HEIGHT = 32;
const MAX_ATTACHMENTS = 6;
const MAX_ATTACHMENT_SIZE = 5 * 1000 * 1000;
const MAX_ROWS = 4;
const INPUT_PADDING = 20;
const BYTES_IN_KB = 1024;
const BYTES_IN_MB = BYTES_IN_KB * 1024;

export { BASE_INPUT_HEIGHT as B, INPUT_PADDING as I, MAX_ATTACHMENT_SIZE as M, MAX_ROWS as a, BYTES_IN_KB as b, BYTES_IN_MB as c, MAX_ATTACHMENTS as d };
//# sourceMappingURL=constants-BPNgncOf.js.map
